/** Canonical conversion event names — provider-agnostic. */
export const ANALYTICS_EVENTS = Object.freeze({
  PAGE_VIEW: "page_view",
  PROJECT_VIEW: "project_view",
  CTA_CLICK: "cta_click",
  CONTACT_FORM_STARTED: "contact_form_started",
  CONTACT_FORM_COMPLETED: "contact_form_completed",
  PROJECT_FORM_STARTED: "project_form_started",
  PROJECT_FORM_COMPLETED: "project_form_completed",
  PARTNER_FORM_STARTED: "partner_form_started",
  PARTNER_FORM_COMPLETED: "partner_form_completed",
  CASTING_FORM_STARTED: "casting_form_started",
  CASTING_FORM_COMPLETED: "casting_form_completed",
  PRODUCTION_NETWORK_FORM_STARTED: "production_network_form_started",
  PRODUCTION_NETWORK_FORM_COMPLETED: "production_network_form_completed",
  PRESS_KIT_DOWNLOADED: "press_kit_downloaded",
  TRAILER_PLAYED: "trailer_played",
  OUTBOUND_LINK_CLICKED: "outbound_link_clicked",
});

/** Safe metadata keys only — never PII or form bodies. */
export const SAFE_META_KEYS = Object.freeze([
  "route",
  "project_slug",
  "cta_label",
  "form_type",
  "source_category",
  "device_class",
  "link_host",
]);

export function sanitizeEventProps(props = {}) {
  const out = {};
  for (const key of SAFE_META_KEYS) {
    if (props[key] == null || props[key] === "") continue;
    const value = String(props[key]).slice(0, 200);
    out[key] = value;
  }
  return out;
}
